export enum globalEvents {
  SET_CREDENTIALS = "set-credentials",
  USER_CLEAR = "user-clear",
  APPOINTMENT_RESCHEDULED = "appointment-rescheduled",
  /**
   * Fired when the authenticated user ID changes (from parsed access token).
   * Use this to reload user-specific cached data.
   * Unlike SET_CREDENTIALS, this only fires when the actual user changes,
   * not on token refresh for the same user.
   */
  USER_CHANGED = "user-changed",
  PUSH_NOTIFICATION_ACTION = "push-notification-action",
  QUESTIONNAIRE_STARTED = "questionnaire-started",
  QUESTIONNAIRE_SAVED = "questionnaire-saved",
  POPUP_CLOSED = "popup-closed",
  DATA_SUBMITTED = "data-submitted",
  OBSERVATION_IMPORTED = "observation-imported",
  VIDEO_ENDED = "video-ended",
  VIDEO_INITIALIZED = "video-initialized",
  SKIP_VISIT = "skip-visit",
  SCHEDULE_VISIT = "schedule-visit",
  LIFESTYLE_MODE_CHANGED = "lifestyle-mode-changed"
}
